import './faq.scss';
import { getOffset, smoothScrollTo } from './../../utilities/js/helper';

class Faq {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-faq',
            categoryAttr: 'category',
            entryAttr: 'entry',
            categorySelector: 'data-faq-category',
            navigationAttr: 'navigation'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$faq = element;
        this.$faqCategories = this.$faq.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.categoryAttr + '"]');
        this.$faqNavigation = this.$faq.querySelector('[' + this.settings.initAttr + '="' + this.settings.navigationAttr + '"]');
        this.$faqEntries = this.$faq.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.entryAttr + '"]');

        this.initialize();
    }

    initialize () {
        this.initFaqCategories();
    }

    initFaqCategories () {
        const setActive = (id) => {
            const $items = this.$faqNavigation.querySelectorAll('label');

            for (let i = 0; i < $items.length; i++) {
                const $item = $items[i];

                if ($item.getAttribute('for') === id) {
                    $item.classList.add('is--active');
                } else {
                    $item.classList.remove('is--active');
                }
            }
        };

        const setActiveEntry = (id) => {
            for (let i = 0; i < this.$faqEntries.length; i++) {
                const $entry = this.$faqEntries[i];

                if ($entry.id !== id) {
                    $entry.checked = false;
                }
            }

            const $activeEntry = document.getElementById(id);
            const entryOffset = getOffset($activeEntry);
            smoothScrollTo(0, entryOffset.top, 1000);
        };

        const $activeFaqItem = this.$faq.querySelector('[' + this.settings.initAttr + '="' + this.settings.entryAttr + '"]:checked');
        if ($activeFaqItem) {
            const categoryId = $activeFaqItem.getAttribute(this.settings.categorySelector);

            if (categoryId) {
                const $activeCategory = document.getElementById(categoryId);

                if ($activeCategory) {
                    $activeCategory.checked = true;
                    setActive(categoryId);

                    window.setTimeout(() => {
                        const entryOffset = getOffset($activeFaqItem);
                        smoothScrollTo(0, entryOffset.top);
                    }, 150);
                }
            }
        }

        this.$faq.addEventListener('change', (e) => {
            if (e.target.getAttribute(this.settings.initAttr) === this.settings.categoryAttr) {
                console.log('category');
                setActive(e.target.id);
            }

            if (e.target.getAttribute(this.settings.initAttr) === this.settings.entryAttr) {
                console.log('entry');
                setActiveEntry(e.target.id);
            }
        });
    }
}

export { Faq };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$faq = $context.querySelectorAll('[data-faq="root"]');
        for (let i = 0; i < $$faq.length; i++) {
            const $faq = $$faq[i];

            const faqAPI = new Faq($faq);
            $faq.API = faqAPI;
        }
    }
});
